import { CheckCircle, Cancel, People } from '@mui/icons-material';
import { Card, CardContent, Typography, Box, Divider } from '@mui/material';
import { useEffect } from 'react';
import SummarizeIcon from '@mui/icons-material/Summarize';
export function AttendanceSummary({ absent, students }) {
  const getAttendancePercentage = () => {
    if (students - absent == 0) return 0;
    return (((students.length - absent) / students.length) * 100).toFixed(2);
  };

  const percentage = getAttendancePercentage();
  const percentageColor =
    percentage >= 80
      ? 'text-green-600'
      : percentage >= 60
        ? 'text-orange-600'
        : 'text-red-600';

  useEffect(() => {}, [absent, students]);
  return (
    <Card className=' rounded-lg border w-full shadow-md '>
      <CardContent className='min-[700px]:p-6'>
        <div className='flex gap-2 items-center mb-2'>
          <SummarizeIcon />
          <Typography variant='h6' className=' font-medium'>
            Attendance Summary
          </Typography>
        </div>

        <div className='grid  gap-2'>
          <Box className='flex items-center justify-between'>
            <Box className='flex items-center gap-2'>
              <People className='size-6 text-blue-600' />
              <Typography variant='body1'>Total Students</Typography>
            </Box>
            <Typography variant='body1' className='font-medium'>
              {students.length || 0}
            </Typography>
          </Box>

          <Box className='flex items-center justify-between'>
            <Box className='flex items-center gap-2'>
              <CheckCircle className='size-6 text-green-600' />
              <Typography variant='body1'>Present</Typography>
            </Box>
            <Typography variant='body1' className='font-medium text-green-600'>
              {students.length - absent || 0}
            </Typography>
          </Box>

          <Box className='flex items-center justify-between'>
            <Box className='flex items-center gap-2'>
              <Cancel className='size-6 text-red-600' />
              <Typography variant='body1'>Absent</Typography>
            </Box>
            <Typography variant='body1' className='font-medium text-red-600'>
              {absent || 0}
            </Typography>
          </Box>
        </div>

        <Divider className='my-2' />

        <Box className='flex items-center justify-between pt-2'>
          <Typography variant='body1'>Attendance Percentage</Typography>
          <Typography
            variant='body1'
            className={`font-medium ${percentageColor}`}
          >
            {percentage}%
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
